import type { Dispatch } from 'redux';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { connect } from '@atlassian/jira-react-redux';
import { saveRunAsUser, setShowMisconfiguredDialog } from '../../../../state/actions/run-as-user';
import {
	misconfiguredRunAsUserDialogIsOpen,
	getRunAsUserSubmitStatus,
} from '../../../../state/selectors/run-as-user';
import type { State as SummaryState } from '../../../../state/types';
import DialogContent from '../dialog-content';
import MisconfiguredSettingsDialog from './view';

const mapStateToProps = (state: SummaryState) => ({
	isOpen: misconfiguredRunAsUserDialogIsOpen(state),
	submitStatus: getRunAsUserSubmitStatus(state),
	ContentComponent: DialogContent,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onSave: (accountId: string, event?: UIAnalyticsEvent) =>
		dispatch(saveRunAsUser(accountId, event)),
	onClose: () => dispatch(setShowMisconfiguredDialog(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MisconfiguredSettingsDialog);
